export default __webpack_public_path__ + "static/media/CapaDownloadAppBanner.b1317f64.svg";